// DEV
const HOST_URL = "https://api.laporankas.com";
const HOST_URL_USU = "https://api-usu.laporankas.com";
const HOST_URL_MP = "https://api-mp.laporankas.com";
const HOST_URL_PKU = "https://api-pku.laporankas.com";
const HOST_URL_FILE_MANAGER = "https://files-manager";
const MY_URL = "http://localhost:3100";
const SLC_LOGIN_URL = "http://localhost:3200/login";
const APP_NAME = "PARKING";
const APP_LOGIC_NAME = "extra-parking-excel";
const SECRET_KEY = "SECRET#1101";
const TAG = "extra-parking-excel-";

// PRODUCTION
// const HOST_URL = "http://192.168.1.134/produksi/backend/public";
// const HOST_URL_FILE_MANAGER = "http://192.168.1.134/mine/images-gallery/public";
// const MY_URL = "http://produksi.localhost";
// const SLC_LOGIN_URL = "http://localhost:3200/login";
// const APP_NAME = "Produksi";
// const APP_LOGIC_NAME = "sttc-produksi";
// const SECRET_KEY = "SECRET#1101";

export {
  HOST_URL,
  HOST_URL_USU,
  HOST_URL_MP,
  HOST_URL_PKU,
  MY_URL,
  HOST_URL_FILE_MANAGER,
  APP_NAME,
  APP_LOGIC_NAME,
  SLC_LOGIN_URL,
  SECRET_KEY,
  TAG,
};
